module.exports = __webpack_public_path__ + "img/worksbot_img20021107.5c9b1fb2.jpg";